module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/train-70096be25f6196110d2f6d2b4c99f07b.svg";